import React from "react";

const About = () => (
	<section className="py-16 px-4 max-w-5xl mx-auto" id="about">
		<h3 className="text-4xl font-bold mb-4 text-yellow-500">Who We Are</h3>
		<p className="text-gray-800 text-lg">
			Lieuriche International Limited is a leader in the IT industry, offering
			bespoke technology services, software development, IT consulting, and
			digital solutions for enterprises and startups. Our team of skilled
			professionals is driven by innovation and excellence.
		</p>
	</section>
);

export default About;
